import React from 'react';
import ReactHlsPlayer from 'react-hls-player';
import './App.css';

function App() {

  const playerRef = React.useRef<HTMLVideoElement>(null);
  // useEffect(() => {
  // document.addEventListener('keydown', onKeyDown);
  // return () => document.removeEventListener("keydown", onKeyDown)
  //}, [])

  return (
    <div className='video'>
      <ReactHlsPlayer
        playerRef={playerRef}
        //src="https://cdn.jmvstream.com/w/LVW-10893/LVW10893_gYHYD18Dqy/playlist.m3u8"
        //src="https://fb.radiosnaweb.com/hls/player.php?dnipf=5a57bda70564a.streamlock.net&canal=tvcristo&canal2=tvcristo&wowza=1&lar=720&alt=404&tipo=8&buffer=5&autostart=true&mute=50&recurso=0&adap=1"
        src="https://5a57bda70564a.streamlock.net/tvcristo/tvcristo.sdp/playlist.m3u8"
        autoPlay={true}
        controls={true}
        muted={true}
        width="100%"
        height="100%"
        hlsConfig={{
          lowLatencyMode: true,
        }}
        onError={(e) => {
          console.log(e)
        }}
      />
    </div>
  );
}

export default App;
